<template>
  <div class="main">
    <el-row :span="26"
            type="flex"
            justify="space-around">
      <el-col :span="4"
              class="table">
        <h3>现有企业</h3>
        <p>16个</p>
      </el-col>
      <el-col :span="4"
              class="table">
        <h3>现有企业</h3>
        <p>16个</p>
      </el-col>
      <el-col :span="4"
              class="table">
        <h3>现有企业</h3>
        <p>16个</p>
      </el-col>
      <el-col :span="4"
              class="table">
        <h3>现有企业</h3>
        <p>16个</p>
      </el-col>
      <el-col :span="4"
              class="table">
        <h3>现有企业</h3>
        <p>16个</p>
      </el-col>
      <el-col :span="4"
              style="align-self:center;">
        <el-button>新增企业</el-button>
      </el-col>
    </el-row>
    <div class="table">
      <el-row :span="20"
              type="flex"
              justify="space-around">
        <el-col :span="13">
          <h1>现有企业100家</h1>
        </el-col>
        <el-col :span="5"
                style="align-self:center;">
          <el-button>点击进入企业列表</el-button>
        </el-col>
      </el-row>
    </div>
    <div class="table">
      <h1 style="padding-top: 15px;">即将到期企业</h1>
      <el-table :data="tableData"
                style="width: 100%">
        <el-table-column prop="e_name"
                         label="企业名称"
                         width="180">
        </el-table-column>
        <el-table-column prop="number"
                         label="企业人数"
                         width="80">
        </el-table-column>
        <el-table-column prop="name"
                         label="负责人"
                         width="80">
        </el-table-column>
        <el-table-column prop="phone"
                         label="负责人电话"
                         width="120">
        </el-table-column>
        <el-table-column prop="date"
                         label="到期时间"
                         width="100">
        </el-table-column>
        <el-table-column prop="address"
                         label="地址">
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      tableData: [{
        e_name: '岐山县雅韵服装厂',
        number: 25,
        date: '2016-05-02',
        name: '王小虎',
        phone: '12345678910',
        address: '上海市普陀区金沙江路 1518 弄'
      }, {
        e_name: '岐山县雅韵服装厂',
        number: 25,
        date: '2016-05-02',
        name: '王小虎',
        phone: '12345678910',
        address: '上海市普陀区金沙江路 1518 弄'
      }, {
        e_name: '岐山县雅韵服装厂',
        number: 25,
        date: '2016-05-02',
        name: '王小虎',
        phone: '12345678910',
        address: '上海市普陀区金沙江路 1518 弄'
      }, {
        e_name: '岐山县雅韵服装厂',
        number: 25,
        date: '2016-05-02',
        name: '王小虎',
        phone: '12345678910',
        address: '上海市普陀区金沙江路 1518 弄'
      }, {
        e_name: '岐山县雅韵服装厂',
        number: 25,
        date: '2016-05-02',
        name: '王小虎',
        phone: '12345678910',
        address: '上海市普陀区金沙江路 1518 弄'
      }, {
        e_name: '岐山县雅韵服装厂',
        number: 25,
        date: '2016-05-02',
        name: '王小虎',
        phone: '12345678910',
        address: '上海市普陀区金沙江路 1518 弄'
      }]
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.main {
  height: 100%;
  width: 100%;
}
.table {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
  margin-top: 5px;
}
</style>
